import './DinA4GridPreview.css';

type DinA4GridPreviewProps = {
  columns: number;
  rows: number;
};

function DinA4GridPreview({ columns, rows }: DinA4GridPreviewProps) {
  const safeColumns = Math.max(1, columns);
  const safeRows = Math.max(1, rows);

  return (
    <div className="a4-preview">
      <div
        className="a4-preview__grid"
        style={{
          gridTemplateColumns: `repeat(${safeColumns}, 1fr)`,
          gridTemplateRows: `repeat(${safeRows}, 1fr)`
        }}
      >
        {Array.from({ length: safeColumns * safeRows }, (_, index) => (
          <div key={index} className="a4-preview__cell" />
        ))}
      </div>
    </div>
  );
}

export default DinA4GridPreview;